export default "__VITE_ASSET__Cc95ZY$v__"